import { LinksProps } from "../../../../../components/links/types";
import {Translate} from "../../../../../locales/locales-utils";

export const linkProps = (): LinksProps => {
  return [
    {
      title: Translate("Global.Footer.Menu.Column1.Title"),
      elements: [
        {
          text: Translate("Global.Footer.Menu.Column1.Items.0"),
          href: "/pricing/",
        },
        {
          text: Translate("Global.Footer.Menu.Column1.Items.1"),
          href: "/community/myQuiz/",
        },
        {
          text: Translate("Global.Footer.Menu.Column1.Items.2"),
          href: "/community/",
        },
      ]
    },
    {
      title: Translate("Global.Footer.Menu.Column2.Title"),
      elements: [
        {
          text: Translate("Global.Footer.Menu.Column2.Items.0"),
          href: "/team-building/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.1"),
          href: "/brand-promotion/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.2"),
          href: "/lead-generation/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.3"),
          href: "/private-event/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.4"),
          href: "/sport/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.5"),
          href: "/training/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.6"),
          href: "/education/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.7"),
          href: "/events/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.8"),
          href: "/branding/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.10"),
          href: "/promo/"
        },
        {
          text: Translate("Global.Footer.Menu.Column2.Items.11"),
          href: "/dance/"
        }
      ]
    },
    {
      title: Translate("Global.Footer.Menu.Column4.Title"),
      elements: [
        {
          text: Translate("Global.Footer.Menu.Column4.Items.0"),
          href: "/investors/"
        }
      ],
    },
    {
      title: Translate("Global.Footer.Menu.Column3.Title"),
      elements: [
        {
          text: Translate("Global.Footer.Menu.Column3.Items.0"),
          href: "https://myquiz.yonote.ru/share/help",
          target: "_blank"
        },
        {
          text: Translate("Global.Footer.Menu.Column3.Items.1"),
          href: "mailto:hello@myquiz.ru",
        },
      ],
    }
  ];
}
